<div>
    <app-breadcrumb></app-breadcrumb>
</div>

<mat-card>
    <mat-card-content>
        <div class="table-header">
        <h2>Procédures archivées</h2>
        </div>

        <mat-divider></mat-divider>

        <div>
        <form [formGroup]="filter">
            <div class="filter-reset">
            <button
                mat-stroked-button
                title="Réinitialiser les filtres en dessous"
                (click)="resetFilters()"
                [disabled]="!filtersActive">
                <mat-icon style="margin-right: 0.5em !important;">refresh</mat-icon>
                Réinitialiser les filtres
            </button>
            </div>
            <div class="filters">
            <div class="filter-first-line">
                <div class="filter-first-item item">
                <mat-form-field appearance="outline" class="general-filter">
                    <mat-label><mat-icon>search</mat-icon> Procédures archivées</mat-label>
                    <input type="text" placeholder="Mnémonique, titre, mot clé .."  matInput formControlName="general_filter">
                    @if(filter.controls['general_filter'].value) {
                    <mat-icon matSuffix mat-icon-button (click)="clearGeneralFilter()" >close</mat-icon>
                    }
                </mat-form-field>
                </div>
            </div>
            <div class="filter-second-line">
                <mat-form-field appearance="outline" class="type-filter">
                <mat-label>Type</mat-label>
                <mat-select (selectionChange)="applyFilter($event.value, 'type')" placeholder="Sélectionnez un type" formControlName="type">
                    @for(type of types; track type){
                    <mat-option [value]="type.id">{{ type.libelle }}</mat-option>
                    }
                </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="category-filter">
                <mat-label>Catégorie</mat-label>
                <mat-select (selectionChange)="applyFilter($event.value, 'category')" placeholder="Sélectionnez une catégorie" formControlName="category">
                    @for(category of categories; track category){
                    <mat-option [value]="category.id">{{ category.libelle }}</mat-option>
                    }
                </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="mode-filter">
                <mat-label>Mode</mat-label>
                <mat-select (selectionChange)="applyFilter($event.value, 'mode')" placeholder="Sélectionnez un mode" formControlName="mode">
                    @for(mode of modes; track mode){
                    <mat-option [value]="mode.id">{{ mode.libelle }}</mat-option>
                    }
                </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="perimetre-filter">
                <mat-label>Lieu d'utilisation</mat-label>
                <mat-select (selectionChange)="applyFilter($event.value, 'perimetre')" placeholder="Sélectionnez un lieu d'utilisation" formControlName="perimetre">
                    @for(perimetre of perimetres; track perimetre){
                    <mat-option [value]="perimetre.id">{{ perimetre.libelle }}</mat-option>
                    }
                </mat-select>
                </mat-form-field>
            </div>
            </div>
        </form>
        </div>

        <div class="mat-elevation-z1">
        <mat-table class="procedure-table" [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="mnemonique">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Mnémonique</mat-header-cell>
            <mat-cell *matCellDef="let element">
                {{ element.mnemonique }}
            </mat-cell>
            </ng-container>

            <ng-container matColumnDef="version" >
            <mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
            <mat-cell *matCellDef="let element">
                @if (element?.version) {
                <b>v{{ element.version }}</b>
                }
            </mat-cell>
            </ng-container>

            <ng-container matColumnDef="titre">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Titre</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.titre }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.type.libelle }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Catégorie</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.category.libelle }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="mode">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered-cell badge-cell">Mode</mat-header-cell>
            <mat-cell *matCellDef="let element" class="centered-cell badge-cell">
                <span [ngClass]="{
                'status-bubble': true,
                'nominal': element.mode.libelle === 'Nominal',
                'degrade': element.mode.libelle === 'Dégradé',
                'urgence': element.mode.libelle === 'Urgence'
                }" class="badge">
                {{ element.mode.libelle }}
                </span>
            </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dateArchivage">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered-cell">Date archivage</mat-header-cell>
            <mat-cell *matCellDef="let element" class="centered-cell"> {{ element.updatedAt | date:'dd/MM/yyyy' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="perimetre">
            <mat-header-cell class="centered-cell" *matHeaderCellDef mat-sort-header>Lieu d'utilisation</mat-header-cell>
            <mat-cell *matCellDef="let element" class="centered-cell"> {{ element.perimetre.libelle}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="centered-cell action-cell"> Actions</mat-header-cell>
            <mat-cell *matCellDef="let element" class="centered-cell action-cell">
                <button mat-icon-button [matMenuTriggerFor]="menuAction" aria-label="Ensemble des actions">
                <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuAction="matMenu">

                <button class="action-button" (click)="openEditDialog(element.id)" mat-menu-item aria-label="Visualisation de la procédure" title="Visualisation de la procédure">
                    <mat-icon>visibility</mat-icon>
                    <span>Consulter la procédure</span>
                </button>

                <button class="action-button" [disabled]="!element.logigramme?.cells || ( element.logigramme?.cells && element.logigramme.cells.length == 0 )" mat-menu-item (click)="openReadOnlyLogigrammeDialog(element)" title="Visualiser le logigramme dans une pop-up">
                    <mat-icon>device_hub</mat-icon>
                    <span>Consulter le logigramme</span>
                </button>
                </mat-menu>

            </mat-cell>
            </ng-container>

            <div class="no-data" *matNoDataRow>
            <b>Aucune procédure</b>
            </div>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row class="table-row" *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>

        <mat-paginator [pageSizeOptions]="[10, 15, 20]"
                        aria-label="Select page of periodic elements"
                        showFirstLastButtons>
        </mat-paginator>
        </div>

    </mat-card-content>
</mat-card>
